import { useState } from "react";
import toast from "react-hot-toast";

export default function EnquiryPopup({ onClose }) {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    enquiry: "",

    name: "",
    email: "",
    mobile: "",
    service: "",
    companySize: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const mobileError = validateMobile(formData.mobile);
    if (mobileError) {
      setErrors({ ...errors, mobile: mobileError });
      return;
    }

    const nameParts = formData.name.trim().split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(" ");

    const payload = {
      firstName,
      lastName,
      email: formData.email,
      phone: formData.mobile,
      enquiry: formData.enquiry,
      service: formData.service,
      companySize: formData.companySize,
      message: formData.message,
    };

    try {
      const response = await fetch(
        "https://azerotech.com/api/sendContact.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const resultText = await response.text();
      console.log("Server Response:", resultText);

      if (!response.ok) throw new Error("Failed");

      setFormData({
        enquiry: "",
        name: "",
        email: "",
        mobile: "",
        service: "",
        companySize: "",
        message: "",
      });

      setErrors({});
      toast.success("Message sent successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Failed to send message");
    }
  };

  const validateMobile = (mobile) => {
    if (!mobile) return "Mobile number is required";

    if (!/^\d+$/.test(mobile)) {
      return "Only numbers are allowed";
    }

    if (!/^[6-9]/.test(mobile)) {
      return "Must start with 6, 7, 8, or 9";
    }

    if (mobile.length !== 10) {
      return "Must be exactly 10 digits";
    }

    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile" && value !== "" && !/^\d*$/.test(value)) return;

    setFormData({ ...formData, [name]: value });

    if (name === "mobile") {
      setErrors({
        ...errors,
        mobile: validateMobile(value),
      });
    }
  };

  return (
    <div className="fixed inset-0  bg-black/60 backdrop-blur-sm flex items-center justify-center px-4 z-50 ">
      <div className="bg-white w-full max-w-2xl rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[85vh] mt-[15%] md:mt-0">
        <div className="bg-primary text-white px-6  py-5 flex justify-between items-center">
          <h2 className="text-xl md:text-2xl font-bold uppercase">
            Work With Us
          </h2>
          <button
            onClick={onClose}
            className="text-2xl hover:rotate-90 transition"
          >
            ✕
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="p-6 md:p-8 space-y-6 overflow-y-auto"
        >
          <p className="text-center text-gray-600 text-sm">
            Fill the form and we’ll get back to you shortly.
          </p>

          {/* Enquiry & Email */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <InputField
              label="Business Name"
              type="text"
              name="enquiry"
              value={formData.enquiry}
              onChange={handleChange}
            />

            <InputField
              label=" Name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            <InputField
              label="Mobile Number"
              name="mobile"
              type="tel"
              value={formData.mobile}
              onChange={handleChange}
              error={errors.mobile}
            />

            <InputField
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
            />

            <SelectField
              label="Service"
              name="service"
              value={formData.service}
              onChange={handleChange}
              options={[
                "Branding",
                "UI/UX",
                "Mobile Development",
                "CRM Development",
                "Digital Marketing",
              ]}
            />

            <SelectField
              label="Company Size"
              name="companySize"
              value={formData.companySize}
              onChange={handleChange}
              options={[
                "1 to 10",
                "11 to 20",
                "20 to 50",
                "50 to 100",
                "More than 100",
              ]}
            />
          </div>

          {/* Mobile & Service */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6"></div>

          <div>
            <label className="text-sm text-gray-500 mb-1 block">Message</label>
            <textarea
              rows="4"
              name="message"
              type="text"
              required
              value={formData.message}
              onChange={handleChange}
              className="w-full border rounded-xl px-4 py-3 focus:ring-2 focus:ring-primary outline-none resize-none"
            />
          </div>

          <div className="text-center pt-4">
            <button
              type="submit"
              className="bg-primary text-white px-10 py-3 rounded-full font-semibold hover:scale-105 transition duration-300 shadow-lg"
            >
              Send Message
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function InputField({ label, name, value, onChange, type = "text", error }) {
  return (
    <div>
      <label className="text-sm text-gray-500 mb-1 block">{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className={`w-full border rounded-xl px-4 py-3 focus:ring-2 outline-none 
          ${error ? "border-red-500 focus:ring-red-400" : "focus:ring-primary"}`}
      />

      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}


function SelectField({ label, name, value, onChange, options }) {
  return (
    <div>
      <label className="text-sm text-gray-500 mb-1 block">{label}</label>
      <select
        name={name}
        required
        value={value}
        onChange={onChange}
        className="w-full border rounded-xl px-4 py-3 focus:ring-2 focus:ring-primary outline-none"
      >
        <option value="">Select {label}</option>
        {options.map((opt, i) => (
          <option key={i} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
}
